// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"4785bc8e","82":"15c822a7","241":"7e78296a","358":"c9f72f89","793":"af8ecf15","982":"4d23db96"}[chunkId] + ".chunk.js";
};